import { ActionIcon } from '@mantine/core';
import { TimeInput } from '@mantine/dates';
import { IconClock } from '@tabler/icons-react';
import { useRef } from 'react';

import classes from './index.module.css';

const CustomTimePicker = (props: any) => {
  const ref = useRef<any>(null);

  const pickerControl = (
    <ActionIcon variant={'subtle'} color={'gray'} onClick={() => ref.current?.focus()}>
      <IconClock size={16} stroke={1.5} />
    </ActionIcon>
  );

  const convertToTimeString = (val: number) => {
    const hoursString = val.toString().padStart(2, '0');
    return `${hoursString}:00`;
  }

  return (
    <TimeInput
      classNames={{ input: `${classes.input}, ${classes.centeredText}` }}
      withAsterisk={props.required}
      ref={ref}
      rightSection={pickerControl}
      {...props}
      minTime={convertToTimeString(props.min)}
      maxTime={convertToTimeString(props.max)}
    />
  )
};

export default CustomTimePicker;